<template>
  <Card title="Cost Trends">
    <div class="flex flex-col w-full px-2 py-4 relative">
      <VueLoading :active.sync="loading" :is-full-page="false" />
        <CostsMetricsGraph
          v-if="metrics.length > 0"
          :metrics="metrics"
          :name="'test'"
          :id="id"
          :activeType="activeType"
          :key="id"
        />
      <p class="text-center text-sm text-gray-500 mt-4">[Insert AI breakdown here]</p>
    </div>
  </Card>
</template>

<script>
import CostsMetricsGraph from '@/components/CostsMetricsGraph'
import HTTP from '@/common/http'
import { mapGetters } from 'vuex'
import Card from '../Card.vue'
import VueLoading from 'vue-loading-overlay'

export default {
  name: 'CostGraphCard',
  components: {
    CostsMetricsGraph,
    Card,
    VueLoading
  },
  props: {
    id: {
      type: String,
      default: 'AllContracts'
    }
  },
  data () {
    return {
      metrics: [],
      loading: false
    }
  },
  computed: {
    ...mapGetters(['activeType'])
  },
  methods: {
    fetchMetrics () {
      this.loading = true
      HTTP.get(`/costs/metrics/${this.activeType}/${this.id}/month`)
        .then(response => {
          this.metrics = response.data.metrics
        })
        .catch(error => {
          this.flashMessage.error({
            message: `Error fetching metrics: ${(error.response && error.response.data && error.response.data.error) || error.message}`
          })
        })
        .finally(() => {
          this.loading = false
        })
    }
  },
  watch: {
    id: {
      immediate: true,
      handler: 'fetchMetrics'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Cards/GraphCards/CostGraphCard.vue